import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckoutModal from "../../components/shop/CheckoutModal";
import ShopNavbar from "../../components/shop/ShopNavbar";
import { useCart, readBuyNowItem, clearBuyNowItem } from "../../context/CartContext";
import { T, F } from "../../config/shop";

export default function CheckoutPage() {
  const location = useLocation();
  // key → a fresh copy whenever the mode changes (cart ↔ buy-now)
  return <CheckoutInner key={location.search} />;
}

function CheckoutInner() {
  const location = useLocation();
  const navigate = useNavigate();
  const { items: cartItems, clearCart } = useCart();

  const isBuyNow = new URLSearchParams(location.search).get("mode") === "buy-now";

  // Snapshot the items once. When the order succeeds we clear the cart, and
  // without a snapshot the page would flip to "empty" and the confirmation
  // screen would vanish.
  const [checkoutItems] = useState(() => {
    if (isBuyNow) {
      const item = readBuyNowItem();
      return item ? [item] : [];
    }
    return cartItems;
  });

  const handleClose = () => {
    if (location.key !== "default") navigate(-1);
    else navigate(isBuyNow ? "/shop" : "/cart");
  };

  const handleSuccess = () => {
    if (isBuyNow) clearBuyNowItem();
    else clearCart();
  };

  if (checkoutItems.length === 0) {
    return (
      <div style={{ minHeight: "100vh", background: T.surface, fontFamily: F.body, color: T.ink }}>
        <ShopNavbar showCart={false} />
        <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "30px 20px" }}>
          <div style={{ width: "100%", maxWidth: 480, textAlign: "center", padding: "44px 28px", background: T.white, border: `1px solid ${T.border}`, borderRadius: 6 }}>
            <h1 style={{ margin: "0 0 10px", fontFamily: F.display, fontSize: 22, fontWeight: 800 }}>Nothing to check out</h1>
            <p style={{ margin: "0 0 24px", color: T.muted, lineHeight: 1.6, fontSize: 14 }}>
              Your {isBuyNow ? "selection" : "cart"} is empty. Pick a product and come back here to pay.
            </p>
            <button
              type="button"
              onClick={() => navigate("/shop")}
              style={{ border: "none", borderRadius: 2, padding: "13px 26px", background: T.black, color: T.yellow, fontWeight: 700, fontSize: 13.5, cursor: "pointer", fontFamily: F.body }}
            >
              Browse product
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: T.surface }}>
      <ShopNavbar showCart={false} />
      <CheckoutModal
        items={checkoutItems}
        onClose={handleClose}
        onSuccess={handleSuccess}
        onContinue={() => navigate("/")}
      />
    </div>
  );
}
